import React from 'react';

const Copyright: React.FC = () => <>© {new Date().getFullYear()}</>;

export default Copyright;